import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import _possibleConstructorReturn from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/getPrototypeOf";
import _inherits from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/inherits";
import axios from "axios";
import ProjectRelatedBaseData from "./ProjectRelatedBaseData";

var ReplacementReserveSuspension =
/*#__PURE__*/
function (_ProjectRelatedBaseDa) {
  _inherits(ReplacementReserveSuspension, _ProjectRelatedBaseDa);

  function ReplacementReserveSuspension() {
    _classCallCheck(this, ReplacementReserveSuspension);

    return _possibleConstructorReturn(this, _getPrototypeOf(ReplacementReserveSuspension).call(this, "ReplacementReserveSuspension"));
  }

  _createClass(ReplacementReserveSuspension, [{
    key: "GetAllSuspensions",
    value: function () {
      var _GetAllSuspensions = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.get("/api/".concat(this._controller, "/GetAllSuspensions")));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function GetAllSuspensions() {
        return _GetAllSuspensions.apply(this, arguments);
      }

      return GetAllSuspensions;
    }()
  }, {
    key: "SuspensionRequestExists",
    value: function () {
      var _SuspensionRequestExists = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(projectId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/".concat(this._controller, "/SuspensionRequestExists/").concat(projectId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function SuspensionRequestExists(_x) {
        return _SuspensionRequestExists.apply(this, arguments);
      }

      return SuspensionRequestExists;
    }()
  }, {
    key: "GetActiveSuspension",
    value: function () {
      var _GetActiveSuspension = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(projectId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/".concat(this._controller, "/GetActiveSuspension/").concat(projectId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function GetActiveSuspension(_x2) {
        return _GetActiveSuspension.apply(this, arguments);
      }

      return GetActiveSuspension;
    }()
  }, {
    key: "SendStatusChangeEmail",
    value: function () {
      var _SendStatusChangeEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(ReplacementReserveSuspensionId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                axios.post("/api/".concat(this._controller, "/SendStatusChangeEmail/").concat(ReplacementReserveSuspensionId));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function SendStatusChangeEmail(_x3) {
        return _SendStatusChangeEmail.apply(this, arguments);
      }

      return SendStatusChangeEmail;
    }()
  }, {
    key: "SendThresholdBrokenEmail",
    value: function () {
      var _SendThresholdBrokenEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(ReplacementReserveSuspensionId) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                axios.post("/api/".concat(this._controller, "/SendThresholdBrokenEmail/").concat(ReplacementReserveSuspensionId));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function SendThresholdBrokenEmail(_x4) {
        return _SendThresholdBrokenEmail.apply(this, arguments);
      }

      return SendThresholdBrokenEmail;
    }()
  }, {
    key: "SendKeepSuspendedEmail",
    value: function () {
      var _SendKeepSuspendedEmail = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(ReplacementReserveSuspensionId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                axios.post("/api/".concat(this._controller, "/SendKeepSuspendedEmail/").concat(ReplacementReserveSuspensionId));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function SendKeepSuspendedEmail(_x5) {
        return _SendKeepSuspendedEmail.apply(this, arguments);
      }

      return SendKeepSuspendedEmail;
    }()
  }, {
    key: "WaitingOnReinstatementSignature",
    value: function () {
      var _WaitingOnReinstatementSignature = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(ReplacementReserveSuspensionId) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", axios.post("/api/".concat(this._controller, "/WaitingOnReinstatementSignature/").concat(ReplacementReserveSuspensionId)));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function WaitingOnReinstatementSignature(_x6) {
        return _WaitingOnReinstatementSignature.apply(this, arguments);
      }

      return WaitingOnReinstatementSignature;
    }()
  }]);

  return ReplacementReserveSuspension;
}(ProjectRelatedBaseData);

export default new ReplacementReserveSuspension();